<template>
  <v-form ref="form">
    <v-card>
      <v-card-title>
        {{ $t("createAuditPeriodForm.title", { year }) }}
      </v-card-title>

      <v-card-text>
        <v-text-field
          v-model="minimalFunds"
          :label="$t('createAuditPeriodForm.minimalFunds.label')"
          type="number"
          min="0"
          required
        ></v-text-field>

        <v-text-field
          v-model="stepModelFunds"
          :label="$t('createAuditPeriodForm.stepModelFunds.label')"
          type="number"
          min="0"
          required
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-btn :disabled="!valid" color="primary" class="mr-4" @click="create" :loading="loading">
          {{ $t("createAuditPeriodForm.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { defaultTo } from "ramda";
import CreateAuditPeriodMutation from "@/gql/mutations/CreateAuditPeriodMutation.gql";

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      minimalFunds: null,
      stepModelFunds: null,
      year: new Date().getFullYear(),
      loading: false,
    };
  },

  computed: {
    valid() {
      return defaultTo(0, this.stepModelFunds) + defaultTo(0, this.minimalFunds) > 0;
    },
  },

  methods: {
    async create() {
      this.loading = true;

      await this.$apollo.mutate({
        mutation: CreateAuditPeriodMutation,
        variables: {
          userId: this.user.id,
          year: this.year,
          minimalFunds: parseInt(defaultTo(0, this.minimalFunds)),
          stepModelFunds: parseInt(defaultTo(0, this.stepModelFunds)),
        },
      });

      this.loading = false;
    },
  },
};
</script>
